export const optionGroup = {
    "modal": {
      "delete": {
        "title": "¿Está seguro que desea eliminar este grupo de opciones?",
        "description": "",
        "error": "Ocurrió un error al eliminar el grupo de opciones",
        "success": "El grupo de opciones se eliminó exitosamente"
      }
    },
    "snackbar": {
      "create": {
        "success": "El grupo de opciones se creó exitosamente",
        "error": "Ocurrió un error al crear el grupo de opciones"
      },
      "update": {
        "success": "El grupo de opciones se actualizó exitosamente",
        "error": "Ocurrió un error al actualizar el grupo de opciones"
      }
    },
    "filter": {
      "title": "Grupo de opciones",
      "filterTitle": "FILTRAR POR",
      "inputs": {
        "search": "Buscar grupo",
        "firstSelect": "Estatus del grupo",
        "rol": "Rol"
      }
    },
    "title": "",
    "informationCard": {
      "submit": {
        "create": "Agregar grupo",
        "edit": "Actualizar grupo"
      },
      "create": {
        "title": "Nuevo grupo de opciones"
      },
      "edit": {
        "title": "Editar grupo de opciones"
      },
      "buttons": {
        "add": "Agregar grupo",
        "cancel": "Cancelar",
        "edit": "Editar grupo"
      }
    }
  }